/**
 * CheckboxFilterGroup
 *
 * Provides the functionality for the filter groups that use checkbox styles.
 *
 * @return {view}
 */

OT.createNS('OT.Redesign.Views.Filters.CheckboxFilterGroup');

OT.Redesign.Views.Filters.CheckboxFilterGroup = Backbone.ViewManager.BaseView.extend({
  events: {
    'click .filters__less'          : 'showLess',
    'click .filters__more'          : 'showMore',
  },

  initialize: function() {
    this.title = $(this.el).data('title');
    this.name = $(this.el).data('name');
    this.paramName = $(this.el).data('paramName');
    var self = this;
    OT.Events.on('filters:update', function(e,filterDiffs) {
      self.toggleFilters(filterDiffs)
    });

    OT.Events.on('results:updated', function() {
      self.render();
    });

    // Not sure why the backbone events setup doens't work for these elements
    $(this.el).find('.filters__label').click(function (e) { self.updateFilteredSearch(e) });
    $(this.el).find('.filters__title--button').click(function (e) { self.toggleFilterAriaExpanded(e) });
  },

  toggleAllFilteredSearch: function (e) {
    var data = e.target.dataset;
    OTSearchBundle.setAllFilters(data.name);
  },
  updateFilteredSearch: function (e) {
    var data = e.target.dataset;
    if (data.id === 'All') {
      return this.toggleAllFilteredSearch(e);
    }
    OTSearchBundle.toggleFilter(data.name, data.id);
  },
  showLess: function (e) {
    $(e.target).parents('.filters__checkbox-group').toggleClass('filters__checkbox-group--expanded filters__checkbox-group--collapsed');
    setTimeout(function() {
      $(e.target).parents('.filters__checkbox-group').find('.filters__more').focus();
    }, 950);
  },
  showMore: function (e) {
    $(e.target).parents('.filters__checkbox-group').toggleClass('filters__checkbox-group--expanded filters__checkbox-group--collapsed');
    setTimeout(function() {
      $(e.target).parents('.filters__checkbox-group').find('li:eq(0) .filters__label').focus();
    }, 950);
  },
  toggleFilterAriaExpanded: function(e) {
    var $target = $("#" + $(e.target).data('target'));
    // when target has a menu-opened class, the target is about to be collapsed and vice versa.
    var expanded = !$target.hasClass('menu-opened');
    $(e.target).attr('aria-expanded', expanded);
  },

  render: function() {
    /***
     * Instead of re-rendering, we opt for modifying the DOM
     * in place; we assume that the filter options will not change
     * between updates which is true today.
     */
    var diffs = OT.Search.Data.get().Filters[this.name].map(function(filter) {
      return {
        value: filter.IsSelected,
        filterName: this.name,
        filterId: filter.Id
      };
    })
    this.toggleFilters(diffs)
  },
  toggleFilters: function(filterDiffs) {
    var self = this;
    filterDiffs.forEach(function (diff){
      if (diff.filterName === self.name) {
        var checkbox = $(self.el).find('.filters__label[data-id="' + diff.filterId + '"]');
        checkbox.attr("aria-pressed", diff.value);
      }
    });
  }
});